// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"MW-z","inlineTitle":"NW-z","sponsoredAdsWrapper":"OW-z","marketplaceRecosWrapper":"PW-z"};